<template>
  <div>
    <el-cascader
      v-model="region"
      :options="options"
      :props="{ expandTrigger: 'hover' }"
      @change="handleChange"
      ref="myCascader"
      v-bind="$attrs"
      :style="{ width: width ? `${width}px` : '100%' }"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { regionData } from 'element-china-area-data'
// import regionJson from '@/json/region-new'

export default {
  props: {
    regionId: {
      type: Array,
      default: () => []
    },
    width: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      options: regionData,
      region: []
    }
  },
  watch: {
    regionId: {
      handler(val) {
        this.region = val
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapState({
      regionList: (state) => state.app.regionList
    })
  },
  methods: {
    handleChange(e) {
      console.log('地区数据 :>> ', e)
      const city = this.$refs.myCascader.getCheckedNodes()[0].parent.label
      const Province = this.$refs.myCascader.getCheckedNodes()[0].parent.parent.label
      // const area = this.$refs.myCascader.getCheckedNodes()[0].label
      this.$emit('update:regionId', e)
      if (city.indexOf('市辖') !== -1) {
        this.$emit('update:region', city)
        return
      }
      this.$emit('update:region', Province)
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
